import 'swiper/swiper-bundle.css'
import '../scss/widget-post-blog.scss'

import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation } from "swiper/modules"
import type { BlogApp } from '../blog-app.props'
import { isDev } from '@/utils/enviroment-detector'

export function WidgetPostBlog({ posts, width, height }: Readonly<BlogApp>) {
    if (!posts?.length) return null

    return (
        <div className="container">
            <div className="destaques-do-blog clearfix">
                <h2>
                    <span>Destaques do blog</span>
                </h2>

                <Swiper
                    modules={[Navigation]}
                    navigation={{
                        nextEl: ".destaques-do-blog .swiper-button-next",
                        prevEl: ".destaques-do-blog .swiper-button-prev",
                    }}
                    spaceBetween={16}
                    rewind
                    breakpoints={{
                        450: { slidesPerView: 2 },
                        700: { slidesPerView: 3 },
                        1100: { slidesPerView: posts.length < 4 ? posts.length : 4 }
                    }}
                >
                    {posts.map((post, i) => (
                        <SwiperSlide key={i}>
                            <div className="postagem">
                                <a href={post.url}>
                                    <div className="image-wrapper">
                                        <figure>
                                            <img
                                                className="lazyload"
                                                src={isDev() ? post.url_midia_post : post.url_midia_post_lazy}
                                                data-src={post.url_midia_post}
                                                alt={post.midia_alt || post.titulo}
                                                width={width}
                                                height={height}
                                            />
                                        </figure>
                                    </div>

                                    <div className="content">
                                        <div className="categoria-postagem">
                                            <h3 className={`categoria-${post.cat_nome}`}>
                                                <span>{post.cat_nome}</span>
                                            </h3>
                                        </div>

                                        <div className="title">
                                            <h2>{post.titulo}</h2>
                                        </div>

                                        <div className="autor-post flex center">
                                            {post.autor_midia_path && (
                                                <div className="imagem-autor">
                                                    <figure>
                                                        <img
                                                            className="lazyload"
                                                            src={isDev() ? post.url_midia_autor : post.url_midia_autor_lazy}
                                                            data-src={post.url_midia_autor}
                                                            alt={post.autor_midia_alt || post.autor}
                                                            width="30"
                                                            height="30"
                                                        />
                                                    </figure>
                                                </div>
                                            )}

                                            <div className="dados-autor-post">
                                                <div className="nome-autor">{post.autor}</div>
                                                <div className="data-views-postagem flex">
                                                    <span className="data-post">
                                                        <span className="text">
                                                            {new Date(post.data_criacao).toLocaleDateString("pt-BR")}
                                                        </span>
                                                    </span>

                                                    {post.num_acessos > 0 && (
                                                        <>
                                                            <span>&nbsp;/&nbsp;</span>
                                                            <span className="data-num-acessos">
                                                                <span className="text">
                                                                    {post.num_acessos.toLocaleString("pt-BR")} view{post.num_acessos > 1 ? "s" : ""}
                                                                </span>
                                                            </span>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
                
                <div className="swiper-button-prev"></div>
                <div className="swiper-button-next"></div>
            </div>
        </div>
    )
}
